import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Academics from "./pages/Academics";
import Admissions from "./pages/Admissions";
import Research from "./pages/Research";
import CampusLife from "./pages/CampusLife";
import Contact from "./pages/Contact";
import Placements from "./pages/Placements";
import Faculty from "./pages/Faculty";
import News from "./pages/News";
import Library from "./pages/Library";
import Hostels from "./pages/Hostels";
import Examinations from "./pages/Examinations";
import International from "./pages/International";
import Alumni from "./pages/Alumni";
import Recruiters from "./pages/Recruiters";
import Clubs from "./pages/Clubs";
import Scholarships from "./pages/Scholarships";
import MediaKit from "./pages/MediaKit";
import Sustainability from "./pages/Sustainability";
import Compliance from "./pages/Compliance";
import Disclosures from "./pages/Disclosures";
import Department from "./pages/Department";
import EventDetail from "./pages/EventDetail";
import NewsArticle from "./pages/NewsArticle";
import FacultyProfile from "./pages/FacultyProfile";
import ClubDetail from "./pages/ClubDetail";
import AlumniProfile from "./pages/AlumniProfile";
import DepartmentAlumnusProfile from "./pages/DepartmentAlumnusProfile";
import ResearchCenter from "./pages/ResearchCenter";
import RecruiterDetail from "./pages/RecruiterDetail";
import IndustryPartnerDetail from "./pages/IndustryPartnerDetail";
import Committees from "./pages/Committees";
import ComplianceCommittee from "./pages/ComplianceCommittee";
import HostelDetail from "./pages/HostelDetail";
import LeadershipMember from "./pages/LeadershipMember";
import Visitors from "./pages/Visitors";
import ServiceWing from "./pages/ServiceWing";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import GalleryAlbum from "./pages/GalleryAlbum";
import DepartmentCourses from "./pages/DepartmentCourses";
import LabDetail from "./pages/LabDetail";
import AcademicCalendar from "./pages/AcademicCalendar";
import Curriculum from "./pages/Curriculum";
import ReportConcern from "./pages/ReportConcern";
import Notifications from "./pages/Notifications";
import { ROUTES } from "./lib/routes";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path={ROUTES.home} element={<Home />} />
        <Route path={ROUTES.about} element={<About />} />
        <Route path={ROUTES.academics} element={<Academics />} />
        <Route path={ROUTES.admissions} element={<Admissions />} />
        <Route path={ROUTES.research} element={<Research />} />
        <Route path={ROUTES.campusLife} element={<CampusLife />} />
        <Route path={ROUTES.contact} element={<Contact />} />
        <Route path={ROUTES.placements} element={<Placements />} />
        <Route path={ROUTES.faculty} element={<Faculty />} />
        <Route path={ROUTES.news} element={<News />} />
        <Route path={ROUTES.library} element={<Library />} />
        <Route path={ROUTES.hostels} element={<Hostels />} />
        <Route path={ROUTES.examinations} element={<Examinations />} />
        <Route path={ROUTES.international} element={<International />} />
        <Route path={ROUTES.alumni} element={<Alumni />} />
        <Route path={ROUTES.recruiters} element={<Recruiters />} />
        <Route path={ROUTES.clubs} element={<Clubs />} />
        <Route path={ROUTES.scholarships} element={<Scholarships />} />
        <Route path={ROUTES.mediaKit} element={<MediaKit />} />
        <Route path={ROUTES.sustainability} element={<Sustainability />} />
        <Route path={ROUTES.compliance} element={<Compliance />} />
        <Route path={ROUTES.disclosures} element={<Disclosures />} />
        <Route path={ROUTES.deptCourses} element={<DepartmentCourses />} />
        <Route path={`${ROUTES.department}/:slug?`} element={<Department />} />
        <Route path={`${ROUTES.department}/:slug/alumni/:alumnus`} element={<DepartmentAlumnusProfile />} />
        <Route path={`${ROUTES.labDetail}/:slug`} element={<LabDetail />} />
        <Route path={ROUTES.events} element={<Events />} />
        <Route path={`${ROUTES.events}/:slug`} element={<EventDetail />} />
        <Route path={ROUTES.gallery} element={<Gallery />} />
        <Route path={`${ROUTES.gallery}/:album`} element={<GalleryAlbum />} />
        <Route path={`${ROUTES.news}/:slug`} element={<NewsArticle />} />
        <Route path={`${ROUTES.faculty}/:id`} element={<FacultyProfile />} />
        <Route path={`${ROUTES.clubs}/:slug`} element={<ClubDetail />} />
        <Route path={`${ROUTES.alumni}/:slug`} element={<AlumniProfile />} />
        <Route path={`${ROUTES.researchCenter}/:slug`} element={<ResearchCenter />} />
        <Route path={`${ROUTES.recruiters}/:slug`} element={<RecruiterDetail />} />
        <Route path={`${ROUTES.intlPartners}/:slug`} element={<IndustryPartnerDetail />} />
        <Route path={ROUTES.committees} element={<Committees />} />
        <Route path={`${ROUTES.committees}/:slug`} element={<ComplianceCommittee />} />
        <Route path={`${ROUTES.hostelDetail}/:slug`} element={<HostelDetail />} />
        <Route path={`${ROUTES.serviceWing}/:slug`} element={<ServiceWing />} />
        <Route path={`${ROUTES.leadership}/:slug`} element={<LeadershipMember />} />
        <Route path={ROUTES.visitors} element={<Visitors />} />
        <Route path={ROUTES.academicCalendar} element={<AcademicCalendar />} />
        <Route path={ROUTES.curriculum} element={<Curriculum />} />
        <Route path={ROUTES.reportConcern} element={<ReportConcern />} />
        <Route path={ROUTES.notifications} element={<Notifications />} />
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}
